import * as React from "react";
import {Link}     from "react-router-dom";

import "./sub-header.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {getAbsLink} from "../get-abs-link";

export const SubHeader = ({backLink, title, navBlock}) => cs(
    consumeContext("routerHistory"),
    ({routerHistory}) => (
        <div className="sub-header sub-header-6s3">
            <div className="left-ui">
                {backLink == null || React.isValidElement<any>(backLink) ? backLink : "to" in backLink ? (
                    <Link
                        className="back"
                        to={backLink.to}
                        xd-qa-type="link"
                        xd-qa-name={backLink.label}
                        onClick={async (e) => {
                            e.preventDefault();
                            if (await navBlock?.block() === true) {
                                return;
                            }
                            routerHistory.push(backLink.to);
                        }}
                    >
                        <i className="fa fa-chevron-left"/>
                        {backLink.label}
                    </Link>
                ) : false}
            </div>

            <div className="title" xd-qa-type="label" xd-qa-name="title">
                {title}
            </div>

            <div className="right-ui"></div>
        </div>
    )
);

